import { type ReactElement } from 'react';
import Input from '@creditflowresearch/uilib/Input';
import Flex from '@creditflowresearch/uilib/Flex';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import usePricingSpread from './usePricingSpread';
import {
  FilterSectionIds,
} from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';

import styles from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/rangeFilter.module.scss';

const PricingSpread = (): ReactElement => {
  const { minValue, maxValue, minMeta, maxMeta, handleMinChange, handleMaxChange } = usePricingSpread();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.PricingSpread }
      header={ <FilterSectionHeader title="PRICING SPREAD (BPS)" /> }
      dataTest="pricingSpreadSection"
    >
      <Flex align="center" gap={ 8 }>
        { /* @ts-ignore */ }
        <Input
          name="pricingSpreadMin"
          type="text"
          placeholder="Min"
          value={ minValue }
          onChange={ handleMinChange }
          meta={ minMeta }
          formFieldClassName={ styles.field }
          inputClassName={ styles.input }
          dataTest="filterMinInput"
          isNarrow
          isClearable={ false }
        />
        <span className={ styles.separator }>-</span>
        { /* @ts-ignore */ }
        <Input
          name="pricingSpreadMax"
          type="text"
          placeholder="Max"
          value={ maxValue }
          onChange={ handleMaxChange }
          meta={ maxMeta }
          formFieldClassName={ styles.field }
          inputClassName={ styles.input }
          dataTest="filterMaxInput"
          isNarrow
          isClearable={ false }
        />
      </Flex>
    </FilterSection>
  );
};

export default PricingSpread;
